<template>
  <div>
    <pointRecharge :pointid='pointid' :pointitem='pointitem' :pointchildName='pointchildName' :visible='ponintVisible' @closePoint="pointshandle"/>
    <capacityRecharge @qixian='qixianHandle' :capacitycount='capacitycount' @renewItem='renewhandle' :capacitydetail='capacitydetail' :capacityitem='capacityitem' :capacitycountry='capacitycountry' :capacitychildName='capacitychildName' :deadline='capacitydeadline' :type='capacitytype' :visible='capacityvisible' @closePoint="capacityhandle"/>
    <editInvoice :edititem=editItem :visible='editVisible' @closePoint="invoicehandle"/>
    <showInvoice :showitem=showItem :visible='showVisible' @closePoint="()=>{showVisible = false}"/>
    <binding :btype="bindingType" :visible='bindingVisible' @closePoint="()=>{bindingVisible = false,emitCallback()}"/>
    <div
      class="toast-layout"
      :style="{background:isLoaing?'none':'rgba(0, 0, 0, 0.3)'}"
      :class="{'toast-active':isLoaing}"
    >
      <div class="loading">
        <svg viewBox="0 0 28 19">
          <path
            d="M4 0l3 3C5.151 4.589 4.141 6.938 4 9c.141 2.994 1.18 5.374 3 7l-3 3c-2.512-2.51-4-5.919-4-10 0-3.134 1.446-6.499 4-9zm20 0c2.554 2.501 4 5.866 4 9 0 4.081-1.488 7.49-4 10l-3-3c1.82-1.626 2.859-4.006 3-7-.141-2.062-1.151-4.411-3-6l3-3z"
          ></path>
        </svg>
      </div>
    </div>
    <div
      class="toast-layout"
      :style="{background:isLoaing?'none':'rgba(0, 0, 0, 0.3)'}"
      :class="{'toast-active':visible}"
    >
      <div class="toast-con" :style="{minWidth:toastType==='comfirm'?'704px':'560px'}">
        <div class="top">
          <span>{{typeTxt}}</span>
          <i
            @click="toastType==='comfirm'?visible=false:emitCallback()"
            class="iconfont icon-cuowu"
          ></i>
        </div>
        <div class="t-line"></div>
        <div class="detail">
          <img :src="img" alt>
          <span v-html="message"></span>
        </div>
        <div class="t-line"></div>
        <div class="bottom" v-if="toastType==='comfirm'">
          <span class="btn primary" @click="emitCallback">{{diycomfirm||comfirmtxt}}</span>
          <span @click="visible=false,cancal()" class="btn cancel">{{lang==='en'?'Cancel':'取消'}}</span>
        </div>
        <div class="bottom mid-bottom" v-else>
          <span class="btn primary" @click="emitCallback">{{diycomfirm||comfirmtxt}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pointRecharge from './pointRecharge'
import capacityRecharge from './capacityRecharge'
import editInvoice from './editInvoice'
import showInvoice from './showInvoice'
import binding from './binding'
import { mapState } from 'vuex'

let types = {
  warn: '提示',
  error: '错误',
  success: '成功'
}

let typesEn = {
  warn: 'Message',
  error: 'Error',
  success: 'Success'
}
export default {
  components: {pointRecharge, binding, capacityRecharge, editInvoice, showInvoice},
  data () {
    return {
      visible: false,
      bindingType: 1,
      capacitytype: '',
      capacityvisible: false,
      ponintVisible: false,
      editVisible: false,
      showVisible: false,
      bindingVisible: false,
      editItem: '',
      showItem: '',
      capacitydetail: '',
      capacitycountry: 0,
      capacitycount: 0,
      capacityitem: '',
      capacitychildName: '',
      capacitydeadline: '',
      pointid: '',
      pointitem: '',
      pointchildName: '',
      message: '',
      type: 'warn',
      toastType: 'show',
      callback: '',
      cancal: '',
      diycomfirm: '',
      isLoaing: false,
      comfirmtxt: localStorage.getItem('language') === 'en' ? 'OK' : '确定',
      img: this.$cdn + 'images/icon/warn.png',
      lang: localStorage.getItem('language')
    }
  },
  computed: {
    ...mapState({
      info: state => state.user.info
    }),
    typeTxt () {
      return this.lang === 'en' ? typesEn[this.type] : types[this.type]
    }
  },
  created () {},
  watch: {
    visible: function (newVal) {
      this.lang = localStorage.getItem('language')
      this.comfirmtxt = this.lang === 'en' ? 'OK' : '确定'
    },
    localStorage: function (newVal) {
      console.log(newVal)
    }
  },
  mounted () {

  },
  methods: {
    qixianHandle (data) {
      this.capacityitem.month = data
    },
    renewhandle (data) {
      this.capacityitem = data.item
      this.capacitycount++
      this.capacitydeadline = data.deadLine
    },
    capacityhandle (data) {
      if (data) {
        this.callback()
      }
      this.capacityitem = ''
      this.capacitycount = 0
      this.capacityvisible = false
    },

    invoicehandle (data) {
      this.editVisible = false
    },

    pointshandle (data) {
      if (data) {
        this.callback()
      }
      this.ponintVisible = false
    },
    emitCallback () {
      this.callback()
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>



// WEBPACK FOOTER //
// src/components/toast/index.vue